// How an integration's two kinds of state read, in one place.
//
// Health and sync were each spelled out in three components, and they had already drifted: the
// same "degraded" was `text-warning-emphasis` in two of them and `text-warning` in the third.
// Only the tones are shared — a card that says "Sync failed" in a sentence and a table column
// headed "Last sync" that says "Failed" are both right, so the wording stays with the caller.
//
// `degraded` is the interesting health state: it still works, partly, which is why it is a
// warning rather than a failure. It and `failed` carry an icon, as every warning and danger
// pill does.
const HEALTH_STATES = {
  ok: { label: 'Healthy', tone: 'success', icon: 'bi-check-lg' },
  degraded: { label: 'Degraded', tone: 'warning' },
  failed: { label: 'Failed', tone: 'danger' },
  unknown: { label: 'Not checked', tone: 'neutral' },
};

export function healthState(status) {
  return HEALTH_STATES[status] || HEALTH_STATES.unknown;
}

const SYNC_STATES = {
  success: { label: 'Success', tone: 'success', icon: 'bi-check-lg' },
  partial: { label: 'Partial', tone: 'warning' },
  failed: { label: 'Failed', tone: 'danger' },
};

export function syncState(status) {
  return SYNC_STATES[status] || { label: 'Not synced yet', tone: 'neutral' };
}
